<div fxLayout="column" style="padding-left: 25px">

    <div fxLayout="row" class="pageTitle">
        <span fxFlex>Ειδοποιήσεις</span>
        <span> <mat-icon (click)="close()">
                close
            </mat-icon>
       </span>
    </div>

    <div fxLayout="column" style="margin-top: 20px;">
        <table mat-table [dataSource]="notifications"  class="mat-elevation-z0">

            <ng-container matColumnDef="mode">
                <th mat-header-cell *matHeaderCellDef>Είδος</th>
                <td mat-cell *matCellDef="let element">
                <mat-icon [ngStyle]="{'color': getColor(element.mode)}">{{getIcon(element.mode)}}</mat-icon>
                </td>
            </ng-container>


            <ng-container matColumnDef="formTitle">
                <th mat-header-cell *matHeaderCellDef>Δήλωση</th>
                <td mat-cell *matCellDef="let element"> {{element.formTitle}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="displayName">
                <th mat-header-cell *matHeaderCellDef> Παιδί </th>
                <td mat-cell *matCellDef="let element"> {{element.displayName}} </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="deadline">
                <th mat-header-cell *matHeaderCellDef> Ημ. Προθεσμίας </th>
                <td mat-cell *matCellDef="let element"> {{element.deadline}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="notificationDate">
                <th mat-header-cell *matHeaderCellDef> Ημ. Ειδοποίησης </th>
                <td mat-cell *matCellDef="let element"> {{element.notificationDate}} </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Ενέργεια </th>
                <td mat-cell *matCellDef="let element">
                    <div fxLayout="row">
                        <mat-icon (click)="navigate(element)"
                                style="align-content:center; vertical-align: middle; color:var(--haeforangePrimary)">
                            keyboard_arrow_right
                        </mat-icon>
                    </div> </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
        </table>
    </div>
</div>
